<div>
  @if (this.watchedAssets.length === 0) {
    <div class="empty_state_container">
      <svg-inline
        src="/assets/images/watchlist-icon-empty.svg"
        class="fav-icon watchlist-img"
        alt="{{ 'watchlist_title' | translate }}" />
      <p class="font-size-16 empty_state_text">
        {{ "dashboard_watchlist_empty_subtitle" | translate }}
      </p>
      <button (click)="addToWatchlist()" class="empty_state_button btn btn-primary btn-inverse">
        {{ "dashboard_watchlist_empty_button_title" | translate }}
      </button>
    </div>
  } @else {
    <table>
      <thead>
        <td></td>
        <td>{{ "all_charts_price_column_label_name" | translate }}</td>
        <td>{{ "all_charts_price_column_label_graph" | translate }}</td>
        <td>{{ "all_charts_price_column_label_price" | translate }}</td>
      </thead>
      <tbody>
        @for (asset of watchedAssets; track asset) {
          <tr
            (click)="openPricePage(asset)"
            (keydown.enter)="openPricePage(asset)"
            [tabIndex]="0">
            <td class="logo-column">
              <img
                [src]="asset.logo"
                (error)="img.src = asset.defaultLogo"
                alt="{{ 'logo_alt_text' | translate }}"
                #img />
            </td>
            <td class="name-column">
              <h4 class="title">{{ asset.name }}</h4>
              <span class="symbol">{{ asset.symbol }}</span>
            </td>
            <td class="chart-column">
              <simple-chart
                [chartWidth]="40"
                [chartHeight]="26"
                [tradable]="asset.tradable"
                [timespan]="timespan"
                [ngClassLine]="asset.colorClass.chart">
              </simple-chart>
            </td>
            <td class="price-column">
              <!-- Change (24 h)% -->
              <div class="change" [ngClass]="asset.colorClass.price">
                {{
                asset.absoluteChange
                | fiat_precision
                | value_change_prefix: asset.valueChangePrefixOptions
                | percent_symbol
                }}
              </div>
              <!-- Current price -->
              <div class="font-size-13">
                {{ asset.fiatAmount | fiat_precision_symbol: asset.fiatPrecisionOptions }}
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>
